import { render, staticRenderFns } from "./relationshipView.vue?vue&type=template&id=33964db5&scoped=true"
import script from "./relationshipView.vue?vue&type=script&lang=js"
export * from "./relationshipView.vue?vue&type=script&lang=js"
import style0 from "./relationshipView.vue?vue&type=style&index=0&id=33964db5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33964db5",
  null
  
)

export default component.exports